<div class="container-fluid mt-2">
    <!-- <card title="Filtros">
        <formulario-dinamico
            [colunas]="filtroPessoalLicencasResource.colunas"
            [(entidade)]="filtro"
            (entidadeChange)="changeFiltro($event)"
        ></formulario-dinamico>
    </card> -->

    <div class="row" *ngFor="let tipo of tiposTeste">
        <listagem-testes-por-tipo [tipo]="tipo" ></listagem-testes-por-tipo>
    </div>


</div>